import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle, debounce } from 'underscore';
import ResizeObserverPolyfill from 'resize-observer-polyfill';




Snappy.Component.ScrollTracking = class ScrollTracking extends Snappy.BaseComponent {
    static get tagName() {
        return 'scroll-tracking';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        this.setParameters();
        this.initResizeObserver();


    }

    initResizeObserver() {
        if (!this.mainContentNode) {
            return;
        }
        const RO = (typeof window.ResizeObserver === 'function') ? window.ResizeObserver : ResizeObserverPolyfill;
        const resizeDebounced = debounce(this.onResizeFinished.bind(this), 1000);
        const ro = new RO((entries) => {
            for (const entry of entries) {
                resizeDebounced();
            }
        });

        ro.observe(this.mainContentNode);
    }

    setVars() {
        this.$document = $(document);
        this.mainContentNode = document.querySelector('#main-content');
        this.maxProgress = 0;
        this.currentSection = this.$element.data('currentSection');
    }

    setEventListeners() {
        const throttledScrollHandler = throttle(this.scrollHandler.bind(this), 700);
        this.$window.on(
            'scroll',
            throttledScrollHandler
        );
    }

    calculatePercentage() {
        const scrollValue = this.$window.scrollTop();
        const progress = scrollValue / (this.documentHeight - this.windowHeight);
        const roundProgress = Math.floor(progress*10) * 10;
        if ( roundProgress > this.maxProgress) {
            this.maxProgress = roundProgress;
            $(window).trigger('gtm:send', [this.currentSection, 'Scroll', roundProgress + '%'])
        }
    }

    onResizeFinished() {
        this.setParameters();
        this.calculatePercentage();
    }

    scrollHandler() {
        this.calculatePercentage();
    }

    setParameters() {
        this.documentHeight = this.$document.height();
        this.windowHeight = this.$window.height();
    }


};



// WEBPACK FOOTER //
// ./components/scroll-tracking/scripts/scroll-tracking.js